(ns app.front.view.licence.search
  (:require [app.domain.licence.model :as licence-model]
            [app.front.dashboard.search :as search]
            [app.front.search-result :as sr]
            [app.front.ui.filter-common :as filter-common]
            [app.front.util :refer [for-frag]]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [potpuri.core :as p]))

(defn- view [_]
  [:div.cloudpermit-page
   [search/workspace-search (<sub [:tr])]])

(defn- cluster-results [results]
  (->> results
       (group-by :address)
       (p/map-vals (fn [vals]
                     (->> vals
                          (group-by :business/names)
                          (p/map-vals (partial group-by :domain/state)))))))

(defn- render-clustered-results [address+results open-result-view tr lang]
  (for-frag [[address business-names+results] address+results]
    [:div.mb-3
     [:h4.uppercase.text-sm
      address]
     (for-frag [[business-names state+results] business-names+results]
       [:div.mt-2
        [:div
         (i18n-model/get-text-from-entities-or-map business-names lang)]
        (for-frag [[state results] state+results]
          [:div.mt-2
           [:div.text-xs.font-bold (tr [state])]
           (for-frag [{:keys [category-names :licence/id] :as result} results]
             [:div.w-full
              [:button.p-3.bg-white.mt-2.w-full.border-0.text-left.select-search-result-button.flex.items-center
               {:on-click #(open-result-view result)}
               [:span.font-bold
                (i18n-model/get-text-from-entities-or-map category-names lang)]
               [:span.ml-2 id]]])])])]))

(defn- action-items-cell [tr {:keys [has-open-inspections? has-open-bills? has-in-progress-application?]}]
  (->> [(when has-open-inspections? (tr [:has-open-inspections?]))
        (when has-open-bills? (tr [:has-open-bills?]))
        (when (and has-in-progress-application?
                   (ff/enabled? :feature-flag.id/licence-search-updates))
          (tr [:has-in-progress-application?]))]
       (remove nil?)
       (str/join ", ")))

(defn- list-view-cols [{:keys [tr lang]}]
  [[:licence/id :licence/id {}]
   [:search-filter-attribute/category-names
    #(i18n-model/get-text-from-entities-or-map (:category-names %) lang)
    {:truncate? true}]
   [:search-filter-attribute/action-items (partial action-items-cell tr) {}]
   [:search-filter-attribute/domain-state (comp tr vector :domain/state) {}]])

(defn- list-view-link [{:keys [tr]}]
  {:make-href   (fn [{group-id :group/id licence-id :licence/id}]
                  (href/href :view/licence (p/map-of group-id licence-id)))
   :description (tr [:search/open-licence])})

(def search-mode {:name                        :licence
                  :search-command              :licence/find
                  :search-config-command       :user/licence-search-config
                  :id-fn                       (fn [{group :group/id
                                                     id    :licence/id}]
                                                 (licence-model/global-id group id))
                  :title                       :dashboard-search/licence-title
                  :subtitle                    :dashboard-search/licence-instructions
                  :filter-subtype              :filter.subtype/licence
                  :filter-value                (fn [attr val]
                                                 (case attr
                                                   :group/id (first val)
                                                   val))
                  :save-filter-command         :user/upsert-licence-filter
                  :remove-filter-command       :user/remove-licence-filter
                  :button-filters              #{}
                  :filter-condition-attributes licence-model/dashboard-filter-condition-attributes
                  :prefers-list-view-flag      :user.config-flag/prefers-licence-dashboard-map-view?
                  :val->str-fn                 (fn [search-config tr attribute]
                                                 (cond
                                                   (= :group/id attribute)
                                                   (fn [v]
                                                     (-> search-config
                                                         :filter-values
                                                         :group/id
                                                         (p/find-first #(= v (first %)))
                                                         second))

                                                   (contains? licence-model/date-range-filter-attributes attribute)
                                                   (partial filter-common/date-range->str tr attribute)

                                                   :else
                                                   (comp tr vector)))
                  :render-search-result        (fn [result {:keys [map-search?]}]
                                                 [sr/licence-search-result-box result map-search?])
                  :map-search-command          :licence/find-for-map
                  :list-view-cols              list-view-cols
                  :list-view-link              list-view-link
                  :cluster-fn                  cluster-results
                  :render-clustered-results    render-clustered-results
                  :default-view                :dashboard-search/list-view})

(def search-view
  {:name        :view/licence-search
   :view        view
   :public?     false
   :controllers [{:start (fn [_]
                           (>evt [::search/init search-mode {}]))}]})
